import IncreasePackagesModal from '@/components/Modals/IncreasePackagesModal';
import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import SubtitlesUpgrade from '@/images/SubtitlesUpgrade.png';
import voicePremiumUpgrade from '@/images/upgrades/voicePremiumUpgrade.svg';
import { UpgradeReason } from '@/pages/AdvancedEditor/utils';
import { useCreditQuery } from '@/state/credits/credits';
import { observer } from 'mobx-react-lite';

interface Props {
    upgradeReason: UpgradeReason;
    showUpgradeModal: boolean;
    setShowUpgradeModal: (value: boolean) => void;
    showIncreasePackageModal: boolean;
    setShowIncreasePackageModal: (value: boolean) => void;
    requiredCredits?: number;
    onCtaClick: (onSuccess?: () => void) => void;
}

export const UpgradeModal = observer(
    ({
        upgradeReason,
        showUpgradeModal,
        setShowUpgradeModal,
        showIncreasePackageModal,
        setShowIncreasePackageModal,
        requiredCredits,
        onCtaClick,
    }: Props) => {
        const { refetch: refetchCredits } = useCreditQuery();

        switch (upgradeReason) {
            case UpgradeReason.CREDITS:
                return (
                    requiredCredits && (
                        <IncreasePackagesModal
                            isOpen={showIncreasePackageModal}
                            setIsOpen={setShowIncreasePackageModal}
                            creditsNeeded={requiredCredits}
                            onUpgrade={() => {
                                refetchCredits();
                                onCtaClick();
                            }}
                        />
                    )
                );
            case UpgradeReason.SUBTITLES:
                return (
                    <UpgradePlanModal
                        open={showUpgradeModal}
                        onClose={() => setShowUpgradeModal(false)}
                        title={<div>Upgrade to add subtitles</div>}
                        imageFile={SubtitlesUpgrade}
                        from="generate subtitles"
                    />
                );
            case UpgradeReason.PREMIUM_VOICE:
                return (
                    <UpgradePlanModal
                        open={showUpgradeModal}
                        onClose={() => setShowUpgradeModal(false)}
                        title={<div>Upgrade to get access to Premium voices </div>}
                        imageFile={voicePremiumUpgrade}
                        from="premium voice"
                        features={[
                            'Additional credits',
                            '100+ Languages & accents',
                            'Access to plug-ins',
                            'API Access',
                            'AI Avatar creation',
                            'Auto generated scripts',
                        ]}
                        ctaText="Upgrade plan"
                    />
                );
            default:
                return null;
        }
    }
);
